import {
  SET_MESSAGES,
  SET_MESSAGE,
  SET_ATTACHMENTS_MESSAGE_LOADING,
  INCREMENT_SENT_MESSAGE_WITH_ATTACHMENTS,
  DELETE_ALL_MESSAGES,
  SET_MESSAGE_MARK
} from '@/store/mutations.js';
import apiRequest from '@/js/helpers/apiRequest.js';
import notify from '@/js/helpers/notify.js';

export default {
  state: {
    messages: [],
    numberOfAttachmentsSent: 0,
    attachmentsMessageLoading: false
  },

  mutations: {
    [SET_MESSAGES]: (state, { messages }) => {
      state.messages.push(...messages);
    },

    [SET_MESSAGE]: (state, { message }) => {
      state.messages.push(message);

      if (message && message.type === 'sent' && message.attachment) {
        state.numberOfAttachmentsSent -= 1;

        if (!state.numberOfAttachmentsSent) {
          state.attachmentsMessageLoading = false;
        }
      }
    },

    [SET_ATTACHMENTS_MESSAGE_LOADING]: (state, payload) => {
      state.attachmentsMessageLoading = payload;
    },

    [INCREMENT_SENT_MESSAGE_WITH_ATTACHMENTS]: state => {
      state.numberOfAttachmentsSent += 1;
    },

    [SET_MESSAGE_MARK]: (state, { messageId, mark }) => {
      state.messages.find(message => message.id === messageId).mark = mark;
    },

    [DELETE_ALL_MESSAGES]: state => {
      state.messages = [];
    }
  },

  actions: {
    sendMessage: async (
      { commit },
      { lessonId, text = '', attachment = [], audio = false } = {}
    ) => {
      try {
        // Если сообщение файл/фото/аудио показываем прелоадер и записываем колличество таких сообщений
        if (!text.length) {
          commit(SET_ATTACHMENTS_MESSAGE_LOADING, true);
          commit(INCREMENT_SENT_MESSAGE_WITH_ATTACHMENTS);
        }

        const body = new FormData();
        body.append('lesson_id', lessonId);
        body.append('text', text);

        if (audio) {
          body.append('files[]', attachment);
        } else {
          body.append('files[]', attachment);
        }

        const res = await apiRequest('lesson/message/create', 'POST', body, true);

        if (res.error) {
          notify({ text: res.error });
          // throw { customeError: res.error };
          return;
        }
      } catch (error) {
        notify({ text: this.$t(`notify.something_went_wrong`) });
        console.error('ERROR_IN:message/create', `MSG:${error.customeError || error.message}`);
      }
    }
  }
};
